import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js"

export default class extends Controller {
  connect() {
    if (!this.element) return
    this.setupMultiStepForm()
    this.applyMasks()
  }

  setupMultiStepForm() {
    let current_fs, next_fs, previous_fs

    document.querySelectorAll(".next").forEach((button) => {
      button.addEventListener("click", function () {
        current_fs = this.parentElement.parentElement.parentElement

        let requiredFields = current_fs.querySelectorAll(".required")
        let valid = true

        requiredFields.forEach((rfield) => {
          let input = rfield.querySelector("input, select, textarea");
          let errorSpan = input.parentElement.querySelector(".invalid-feedback");
        
          if (
            (input.type === "checkbox" && !input.checked) ||
            (input.tagName === "SELECT" && (!input.value || input.value === "")) ||
            (input.type !== "checkbox" && input.tagName !== "SELECT" && !input.value)
          ) {
            input.classList.add("is-invalid");
            if (errorSpan && errorSpan.classList.contains("invalid-feedback")) {
              errorSpan.style.display = "block";
            }
            valid = false;
          } else {
            if (errorSpan) {
              errorSpan.style.display = "none";
            }
            input.classList.remove("is-invalid");
          }
        });               

        if (!valid) return

        next_fs = current_fs.nextElementSibling

        if (!next_fs) return

        document.querySelectorAll(".progressbar li")[Array.from(document.querySelectorAll("fieldset")).indexOf(next_fs)].classList.add("active")

        next_fs.style.display = "block"
        current_fs.style.display = "none"

        let errorExplation = document.querySelector("#error_explanation")
        if (errorExplation){
          errorExplation.classList.add("d-none")
        }
      })
    })

    document.querySelectorAll(".previous").forEach((button) => {
      button.addEventListener("click", function () {
        current_fs = this.parentElement.parentElement.parentElement
        previous_fs = current_fs.previousElementSibling

        if (!previous_fs) return

        document.querySelectorAll(".progressbar li")[Array.from(document.querySelectorAll("fieldset")).indexOf(current_fs)].classList.remove("active")

        previous_fs.style.display = "block"
        current_fs.style.display = "none"
      })
    })
  }

  applyMasks() {
    const birthDateInput = document.querySelector("[name='patient[birth_date]']");
    if (birthDateInput) {
      new Cleave(birthDateInput, {
        date: true,
        delimiter: "/",
        datePattern: ["d", "m", "Y"]
      })
    }

    const cpfInput = document.querySelector("[name='patient[cpf]']")
    if (cpfInput) {
      new Cleave(cpfInput, {
        numericOnly: true,
        delimiters: [".", ".", "-"],
        blocks: [3, 3, 3, 2] // CPF pattern: 000.000.000-00
      })
    }

    const phoneInput = document.querySelector("[name='patient[phone_number]']")
    if(phoneInput) {
      new Cleave(phoneInput, {
        numericOnly: true,
        delimiters: ["(", ") ", "-"],
        blocks: [0, 2, 5, 4], // (XX) XXXXX-XXXX or (XX) XXXX-XXXX
        onValueChanged: function (event) {
          let rawValue = event.target.rawValue.replace(/\D/g, "")
          if (rawValue.length <= 10) {
            event.target.value = rawValue.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3") // Residencial (XX) XXXX-XXXX
          } else {
            event.target.value = rawValue.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3") // Celular (XX) XXXXX-XXXX
          }
        }
      })
    }
  }
}
